import { Observable, merge } from 'rxjs';
import { Pub, State, Sub } from '../../state/state.abstract';

class PubImpl extends Pub<IAppState> {
  networkStatus(networkStatus: IAppState['networkStatus']) {
    this.emit('networkStatus', { networkStatus });
  }
  logOutFromOtherTab() {
    this.emit('logOutFromOtherTab', {});
  }
  companySwitched() {
    this.emit('companySwitched', {});
  }
  notifyAppUpdated() {
    this.emit('newAppVersionAvailable', {});
  }
}

class SubImpl extends Sub<IAppState> {
  protected actionHandlers(): Observable<IAppState> {
    return merge(this.updateState());
  }

  protected updateState(): Observable<IAppState> {
    return this.actionListener([
      'newAppVersionAvailable',
      'networkStatus',
      'logOutFromOtherTab',
      'companySwitched',
    ]);
  }
}

class AppState extends State<IAppState> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const appState = new AppState({ action: undefined, networkStatus: 'online' });

interface IAppState {
  action:
    | 'newAppVersionAvailable'
    | 'networkStatus'
    | 'logOutFromOtherTab'
    | 'companySwitched'
    | undefined;
  networkStatus: 'online' | 'offline';
}
